<template>
  <ResizablePage>
    <template v-slot:content="conentProps">
      <v-container fluid v-bind:style="{ height: conentProps.tableHeight + 'px' }" class="overflow-y-auto" fill-height>
        <v-layout justify-center>
          <v-row style="max-width: 900px">
            <validation-observer style="width: 100%"
                                 class="px-5"
                                 ref="form_validation"
            >
              <v-form
                @submit.prevent="submit"
                :readonly="!editable">

                <v-expansion-panels multiple flat hover v-model="panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.company.group.base") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.company.name"
                            rules="required|max:100"
                          >
                            <v-text-field
                              v-model="name"
                              :counter="100"
                              :error-messages="errors"
                              :label="$t('view.company.name')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.company.code"
                            rules="required|max:50"
                          >
                            <v-text-field
                              v-model="code"
                              :counter="50"
                              :error-messages="errors"
                              :label="$t('view.company.code')"
                              required
                            ></v-text-field>
                          </validation-provider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <validation-provider
                            v-slot="{ errors }"
                            name="view.company.country"
                            rules="required"
                          >
                            <v-select
                              v-model="country"
                              :items="countryItems"
                              :error-messages="errors"
                              item-text="code"
                              :label="$t('view.company.country')"
                              required
                            >
                              <template v-slot:selection="data">
                                <country-flag :country="data.item.code" size="normal" class="normal-flag-move" />
                                {{ data.item.name }}
                              </template>
                              <template v-slot:item="data">
                                <country-flag :country="data.item.code" size="normal" class="normal-flag-move" />
                                {{ data.item.name }}
                              </template>
                            </v-select>
                          </validation-provider>
                        </v-col>
                      </v-row>

                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>{{ $t("view.company.group.perms") }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-card elevation="0" outlined>
                            <v-card-text>
                              <v-checkbox
                                v-model="moduleContracts"
                                :value="moduleContracts"
                                :label="$t('view.company.module_contracts')"
                                type="checkbox"
                              />

                              <v-divider class="pa-2" />

                              <v-checkbox
                                v-model="active"
                                :value="active"
                                :label="$t('view.company.active')"
                                type="checkbox"
                              ></v-checkbox>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-form>
            </validation-observer>
          </v-row>
        </v-layout>

        <v-snackbar
          v-model="showError"
          bottom
          light
          timeout="-1"
          color="red lighten-4"
        >
          {{ errorMessage }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="indigo"
              text
              v-bind="attrs"
              @click="showError = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-container>
    </template>
  </ResizablePage>
</template>

<script>
import utils from "@/utils";
import ResizablePage from "@/components/ResizablePage";

export default {
  name: "CompanyView",
  components: { ResizablePage },
  data() {
    return {
      editable: this.canWrite("company"),
      canLeave: !this.canWrite("company"),
      panels: [0],

      name: "",
      code: "",
      active: true,
      moduleContracts: false,
      country: null,
      record: null,
      countryItems: [
        { code: "sk", name: "Slovakia" },
        { code: "cz", name: "Czech Republic" },
        { code: "de", name: "Germany" },
        { code: "hu", name: "Hungary" }
      ],
      showError: false,
      errorMessage: null
    };
  },

  methods: {
    async store() {
      if (this.$refs.form_validation.validate()) {

        let object = {
          code: this.code,
          name: this.name,
          active: this.active,
          moduleContracts: this.moduleContracts,
          countryCode: this.country.toUpperCase()
        };

        let params = {
          module: "company",
          object: object
        };

        if (!utils.isObjectEmpty(this.$store.state.data.record)) {
          params.id = this.record.companyId;
          object.companyId = this.record.companyId;
          object.lastChange = this.record.lastChange;
        }

        let response = await this.$store.dispatch("data/storeRecord", params);

        if (response.error) {
          this.showError = true;
          this.errorMessage = response.message;
        } else {
          this.canLeave = true;
          this.$router.close({ name: "data/companies" });
        }
      }
    },

    async remove() {
      let params = {
        module: "company",
        id: this.record.companyId
      };

      let response = await this.$store.dispatch("data/deleteRecord", params);

      if (response.error) {
        this.showError = true;
        this.errorMessage = response.message;
      } else {
        this.canLeave = true;
        this.$router.close({ name: "data/companies" });
      }
    },

    cancel() {
      this.canLeave = true;
      this.$router.close({ name: "data/companies" });
    }
  },

  watch: {
    "$store.state.data.record": function() {
      if (this.$store.state.data.module === "company" && this.$store.state.data.record !== null) {
        let record = this.$store.state.data.record;

        this.name = record.name;
        this.code = record.code;
        this.active = record.active || true;
        this.moduleContracts = record.moduleContracts;
        this.country = record.countryCode.toLowerCase();
        this.record = record;
      }
    },

    "$store.state.data.activeEvent": function() {
      const e = this.$store.state.data.activeEvent;
      if (e != null && e.target === "view") {
        try {
          if (e.click !== undefined) {
            switch (e.click) {
              case "store":
                this.store();
                break;
              case "cancel":
                this.cancel();
                break;
              case "delete":
                this.remove();
                break;
            }
          }
        } finally {
          this.$store.dispatch("data/processEvents");
        }
      }
    }
  },

  mounted() {
    this.$store.dispatch("data/resetEvents");

    if (this.$route.params.id === "new")
      this.$store.dispatch("data/fetchRecord", { module: "company" });
    else
      this.$store.dispatch("data/fetchRecord", { module: "company", id: this.$route.params.id });
  },

  async beforeRouteLeave(to, from, next) {
    if (this.canLeave)
      next();
    else {
      const answer = window.confirm(this.$t("view.leave_msg"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.normal-flag-move
  margin: -10px -5px !important
</style>
